import { API_URL } from "@/constants/environment";
import axios from "axios";




class VendorAuthService {
    constructor() {
      this.api = axios.create({
        baseURL: API_URL,
        timeout: 10000,
      });
  
      // Request Interceptor
      this.api.interceptors.request.use(
        (config) => {
          const token =
            localStorage.getItem("access_token") ||
            localStorage.getItem("onboard_access_token");
      
          if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
          } else {
            // Optional: Explicitly set to null if your backend expects the header
            // But best practice is to not set the header at all
            config.headers["Authorization"] = null;
          }
      
          return config;
        },
        (error) => Promise.reject(error)
      );
  
      // Response Interceptor
      this.api.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error.response?.status === 401) {
            console.log("Unauthorized request");
          }
          return Promise.reject(error);
        }
      );
    }
  
    // Generic API request helper
    async request(method, url, data = {}) {
      try {
        const response = await this.api[method](url, data);
        return response.data;
      } catch (error) {
        throw error; // ✅ Throwing error here to propagate it to the caller
      }
    }
  
    // Auth Methods
    signUp(userData) {
      return this.request("post", "/vendors/register", userData);
    }
  
    login(email, password) {
      return this.request("post", "/vendors/login", { email, password });
    }
  
    updatePassword(currentPassword, newPassword) {
      return this.request("post", "/vendors/change-password", {
        currentPassword,
        newPassword,
      });
    }
  
    sendForgetPasswordOtp(email) {
      return this.request("post", "/vendors/forgot-password", { email });
    }
  
    verifyResetPasswordOtp(email, otp) {
      return this.request("post", "/vendors/verify-otp", { email, otp });
    }
  
    resetPassword(email, newPassword) {
      return this.request("post", "/vendors/reset-password", {
        email,
        newPassword,
      });
    }
  
    logout() {
      return this.request("post", "/vendors/logout");
    }
  
    resendEmailOtp(email) {
      return this.request("post", "/vendors/resend-email-otp", { email });
    }
  
    verifyEmailOtp(email, otp) {
      return this.request("post", "/vendors/verify-email-otp", { email, otp });
    }
  }
  
  const vendorAuthService = new VendorAuthService();
  export default vendorAuthService;
  